import NavbarFilters from './NavbarFilters';

export default NavbarFilters;
